// Display helpers. Tiny floating-point dust (e-10) from the API is rounded to 0.
export function money(n) {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return '—';
  const v = Math.abs(Number(n)) < 1e-6 ? 0 : Number(n);
  return v.toLocaleString('en-US', { maximumFractionDigits: 0 });
}

export function clean(n) {
  const v = Number(n);
  return Math.abs(v) < 1e-6 ? 0 : v;
}

// Shorten long GL account names for chart labels.
export function shortName(name = '') {
  return name.replace(/\s*\(.*?\)\s*/g, '').replace(/,$/, '').trim();
}
